import React from "react";
import { HiOutlineUsers } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneDance } from "../../../lib/sysNavigation/SysNavigation";

type DanceRow = {
  dance_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<DanceRow>
    type={_TYPES_.DANCE}
    title="Dance"
    subtitle="Dance content promoted on the public site."
    icon={<HiOutlineUsers className="h-5 w-5" />}
    addRoute="/data/dance/add"
    editRoute="/data/dance/edit"
    pushOne={pushOneDance}
    dataKey="dances"
    countKey="dancesCount"
    idField="dance_id"
  />
);

export default Overview;
